module.exports = __webpack_public_path__ + "static/media/project-4.e968af6c.PNG";